import { Component, Input, OnInit } from '@angular/core';

import { NbMenuService, NbSidebarService, NbThemeService, NbMenuItem } from '@nebular/theme';
import { LayoutService } from '../../../@core/utils';
import { UsersService } from '../../../@core/backend/common/services/users.service';
import { IUserDTO } from '../../../@core/backend/common/dto/user-dto';
import { AvisosService } from '../../../@core/backend/common/services/avisos.service';
import { IAvisoDTO } from '../../../@core/backend/common/dto/aviso-dto';
import { ParametrosService } from '../../../@core/backend/common/services/parametros.service';

@Component({
    selector: 'ngx-header',
    styleUrls: ['./header.component.scss'],
    templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {

    @Input()
    position = 'normal';

    user: IUserDTO;
    userMenu = this.getMenuItems();

    private _nomeEmpresa: string;

    constructor(private sidebarService: NbSidebarService,
        private menuService: NbMenuService,
        private userService: UsersService,
        private layoutService: LayoutService,
        private themeService: NbThemeService,
        private _parametrosService: ParametrosService
    ) { }

    get nomeEmpresa() {
        return this._nomeEmpresa;
    }

    get picture() {
        if (!this.user || this.user.Picture == null)
            return null;

        return 'data:image/png;base64,' + this.user.Picture;
    }

    logoUrl: string;

    public get logo(): any {
        const result = { 'background-image': this.logoUrl };
        return result;
    }
    getMenuItems() {
        return [
            { title: 'Perfil', link: '/pages/perfil' },
            { title: 'Sair', link: '/auth/logout' },
        ];
    }

    ngOnInit() {
        this.userService.getCurrentUser().subscribe((user: any) => {
            this.user = user;
            this.userMenu = this.getMenuItems();
        });

        this.themeService.getJsTheme().subscribe(theme => {
            this._nomeEmpresa = theme.variables.empresa as string;
        });

        this._parametrosService.getLogo().subscribe((res) => {
            if (res && res.Url)
                this.logoUrl = `url('${res.Url}')`;
            else
                this.logoUrl = "url('../../../../assets/images/logo.jpg')";
        });
    }

    toggleSidebar(): boolean {
        this.sidebarService.toggle(true, 'menu-sidebar');
        this.layoutService.changeLayoutSize();

        return false;
    }

    goToHome() {
        this.menuService.navigateHome();
    }
}
